/**
 * Перевести время в тайм-зону UTC+5
 *
 * @param {Number} time
 * @return {Number}
 */
export default function getTimeUtc5(time) {
  return Date.parse(new Date(time).toLocaleString("en-US", { timeZone: "Asia/Yekaterinburg" }));
}
